import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Swal from 'sweetalert2';
import Select from 'react-select';
import {
  Box
} from '@mui/material';

const EmployeeWorkTime = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  let season_id = localStorage.getItem("season_id");

  const [equipelist, setEquipelist] = useState([]);
  const [matriculelist, setMatriculelist] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [employeeslist, setEmployeeslist] = useState([]);
  const genderlist = [
    { value: 'H', label: "H ( Man ) " },
    { value: 'F', label: "F ( Woman )" }
  ]; ''
  const [formData, setFormData] = useState({
    location: '',
    gender: '',
    employee: '',
    shift: '',
    start_date: '',
    end_date: '',
    //equipe:'',
    equipe: [],
    matricule: [],
    season_id: season_id,
  });
  const shiftlist = [
    { value: 1, label: "Shift 1" },
    { value: 2, label: "Shift 2" }
  ];

  const defaultDate = (formatDate(new Date()));
  useEffect(() => {
    setPermission(FindModuleById(440));
    console.log(permission);
    axios.post("/employees/listing-active-emp-seasonal-working-hours", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });

      axios.post("/employees/get-matricule", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.matricule;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.matricule,
            value: ord.matricule,
            key: `sts-${index}`,
          }));
          setMatriculelist(emp_statusList);
        }
      })
      .catch((error) => {
        console.log(error);
      });

      axios.post("/employees/get-equipe", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.equipe;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.equipe,
            value: ord.equipe,
            key: `sts-${index}`,
          }));
          setEquipelist(emp_statusList);
        }
      })
      .catch((error) => {
        console.log(error);
      });

      


    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code == 200) {
          let locations = response.data.data.locations;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));


          setLocationLoading(emp_statusList);



        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .post("/employees/listing-active-emp-seasonal", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {


        if (response.data.code === 200) {
          let emps = response.data.data.employees;

          let emp_statusList = emps.map((ord, index) => ({
            label: ord.first_name + ' ' + ord.last_name,
            value: ord.id,
            key: `sts-${index}`,
          }));



          setEmployeeslist(emp_statusList);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  AWS.config.setPromisesDependency();
  AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
  });
  const s3 = new AWS.S3();

  // ✅ Functional component for Full Name Cell
  const FullNameCell = ({ renderedCellValue, row }) => {
    let url = '';
    if (row?.original?.profile_picture) {
      const params = { Bucket: AWS_BUCKET, Key: row.original.profile_picture };
      url = s3.getSignedUrl('getObject', params);
    }
    const borderColor = row.original.date ? '#709506' : 'red'; // ✅ Conditional border color

    return (
      <button
        style={{ border: '0', background: 'transparent' }}
        onClick={() => {
          if (permission && permission.add == 1) {
            AddEmpWorkTime(row.original);
          }
        }}
        className="emp-clickable"
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            border: `2px solid ${borderColor}`, // ✅ Dynamic border color
            padding: '0px 10px'
          }}
        >
          <img
            alt="avatar"
            height={70}
            width={70}
            src={url}
            loading="lazy"
            style={{ borderRadius: '100%' }}
          />
          <span>{renderedCellValue}</span>
        </Box>
      </button>
    );
  };
  // ✅ Define PropTypes for FullNameCell
  FullNameCell.propTypes = {
    renderedCellValue: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        profile_picture: PropTypes.string,
        date: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };
  // ✅ Functional component for Details Cell
  const DetailsCell = ({ row }) => {
    return <a className="btn btn-primary" href={`/work-time-tracking-view-all/${row.original.id}`}>View Work Time Tracking</a>;
  };
  // ✅ Define PropTypes for DetailsCell
  DetailsCell.propTypes = {
    renderedCellValue: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };
  const columns = [
    {
      header: 'Full Name',
      accessorFn: (row) => `${row.first_name} ${row.last_name}`,
      Cell: FullNameCell, // ✅ Assigning function directly (No inline)
    },
    {
      accessorKey: 'position',
      header: 'Position',
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.emp_location ? row.emp_location.title : ''}`,
    },
    {
      accessorKey: 'join_date',
      header: 'Join Date',
      accessorFn: (row) => {
        if (!row.join_date) return '';
        const date = new Date(row.join_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      accessorKey: 'status',
      header: 'Status',
    },
    {
      header: 'Employee Status',
      accessorFn: (row) => `${row.emp_status ? row.emp_status.title : ''}`,
    },
      {
      accessorKey: 'equipe',
      header: 'Equipe',
    },
    {
      header: 'Details',
      accessorFn: (row) => `${row.first_name} ${row.last_name}`,
      Cell: DetailsCell, // ✅ Assigning function directly (No inline)
    },
  ];
  useEffect(() => {

    const element = document.getElementById('start_time_1');
    if (element != null) {
      const start_time_1 = document.getElementById('start_time_1').value;

      console.log(start_time_1);
      const end_time_1 = document.getElementById('end_time_1').value;
      const start_time_2 = document.getElementById('start_time_2').value;
      const end_time_2 = document.getElementById('end_time_2').value;

      // Convert time strings to Date objects
      const timeToDate = (time) => {
        const [hours, minutes] = time.split(':');
        const now = new Date();
        now.setHours(hours, minutes, 0, 0);
        return now;
      };

      const startTime1 = timeToDate(start_time_1);
      const endTime1 = timeToDate(end_time_1);
      const startTime2 = timeToDate(start_time_2);
      const endTime2 = timeToDate(end_time_2);

      // Calculate time difference in hours
      const getHoursDiff = (startTime, endTime) => {
        return (endTime - startTime) / (1000 * 60 * 60); // milliseconds to hours
      };

      const shiftHours1 = getHoursDiff(startTime1, endTime1);
      const shiftHours2 = getHoursDiff(startTime2, endTime2);

      // Calculate the total shift hours
      const totalShiftHours = shiftHours1 + shiftHours2;

      // Set the value of shift_hours input
      document.getElementById('shift_hours').value = totalShiftHours;
    }


  })


  const AddEmpWorkTime = async (emp) => {
    console.log(emp);
    let emp_id = emp.id
    const { value: formValues } = await Swal.fire({
      //    title: "'"+emp.first_name+"'<br>Employee Work Time Tracking",
      title: `${emp.first_name}  ${emp.last_name}<br>Employee Work Time Tracking`,

      html: '<div style="display: grid;">     <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Date</label>     <input style="margin: 0em 0em 1em 0em !important;" type="date" id="datePicker" class=" swal2-input" value="' + defaultDate + '"><div style="width:100%;">		<div style="width:50%;float:left"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 1</label> 		   <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="start_time_1" class="swal2-input" placeholder="Start Time" ></div>		<div style="width:50%;float:left;"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 1</label> <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="end_time_1" class="swal2-input" placeholder="End Time"></div> </div>    <div style="width:100%;">		<div style="width:50%;float:left"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 2</label> 		   <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="start_time_2" class="swal2-input" placeholder="Start Time"></div>		<div style="width:50%;float:left;"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 2</label> <input type="time" style="width:100%;;margin: 0em 0em 1em 0em !important;" id="end_time_2" class="swal2-input" placeholder="End Time" ></div> </div>      <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift</label>   <input style="margin: 0em 0em 1em 0em !important;" type="text" id="shift" value="' + emp.shift + '" class="swal2-input" placeholder="Enter Shift">    <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift Hours</label>   <input style="margin: 0em 0em 1em 0em !important;" type="text" id="shift_hours" value="0" class="swal2-input" placeholder="Enter Shift Hours">        <input type="hidden" id="extra_hours" class="swal2-input" value="0" placeholder="Extra Hours">    <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Advance On Salary</label>     <input type="number"  style="margin: 0em 0em 1em 0em !important;" value="0" id="advanced_on_salary" class="swal2-input" placeholder="Advance On Salary"> <div style="text-align: left; padding-left: 5px; margin-top: -20px;">Holiday shift<input type="checkbox"  id="holiday_shift" class="swal2-input" style="margin: 0; position: relative; top: 20px; left: 12px;"></div></div>',

      didOpen: () => {
        const calculateShiftHours = () => {
          const start_time_1 = document.getElementById('start_time_1').value;
          const end_time_1 = document.getElementById('end_time_1').value;
          const start_time_2 = document.getElementById('start_time_2').value;
          const end_time_2 = document.getElementById('end_time_2').value;

          const timeToMinutes = (time) => {
            if (!time) return null;
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
          };

          const getHoursDiff = (startMinutes, endMinutes) => {
            let diff = endMinutes - startMinutes;
            if (diff < 0) diff += 24 * 60; // crosses midnight
            return diff / 60;
          };

          let totalShiftHours = 0;

          if (start_time_1 && end_time_1) {
            const startMins = timeToMinutes(start_time_1);
            const endMins = timeToMinutes(end_time_1);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          if (start_time_2 && end_time_2) {
            const startMins = timeToMinutes(start_time_2);
            const endMins = timeToMinutes(end_time_2);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          document.getElementById('shift_hours').value = totalShiftHours.toFixed(2);
        };

        document.getElementById('start_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('start_time_2').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_2').addEventListener('input', calculateShiftHours);
      },


      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        const date = document.getElementById('datePicker').value;
        const shift = document.getElementById('shift').value;
        const shift_hours = document.getElementById('shift_hours').value;
        const extra_hours = document.getElementById('extra_hours').value;
        const advanced_on_salary = document.getElementById('advanced_on_salary').value;

        const start_time_1 = document.getElementById('start_time_1').value;
        const start_time_2 = document.getElementById('start_time_2').value;
        const end_time_1 = document.getElementById('end_time_1').value;
        const end_time_2 = document.getElementById('end_time_2').value;


        let holiday_shift = 0;
        if (document.getElementById('holiday_shift').checked) {
          holiday_shift = 1;
        } else {
          holiday_shift = 0;
        }
        if (!date) {
          Swal.showValidationMessage('Date is required');
          return null;
        }
        // if (!shift_hours) {
        //   Swal.showValidationMessage('Shift Hours is required');
        //   return null;
        // }
        if (!extra_hours) {
          Swal.showValidationMessage('Extra Hours is required');
          return null;
        }
        if (!advanced_on_salary) {
          Swal.showValidationMessage('Advance On Salary is required');
          return null;
        }

        return { emp_id, date, shift_hours, shift, extra_hours, holiday_shift, advanced_on_salary, start_time_1, start_time_2, end_time_1, end_time_2 };
      }
    });

    if (formValues) {
      try {
        const response = await axios.post(`/employee-work-time-tracking`, {
          season_id: season_id,
          employee_id: formValues.emp_id,
          date: formValues.date,
          shift_hours: formValues.shift_hours,
          shift: formValues.shift,
          extra_hours: formValues.extra_hours,
          holiday_shift: formValues.holiday_shift,
          advanced_on_salary: formValues.advanced_on_salary,
          start_time_1: formValues.start_time_1,
          start_time_2: formValues.start_time_2,
          end_time_1: formValues.end_time_1,
          end_time_2: formValues.end_time_2
        }, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        });

        if (response.data.code === 200) {
          Swal.fire(
            'Success!',
            'Employee Work Time Tracking added Successfully.',
            'success'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'There was a problem Employee Work Time Tracking.',
          'error'
        );
      }
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post("/employees/listing-active-emp-seasonal-working-hours", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {


        if (response.data.code === 200) {

          setData(response.data.data.employees);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });

  }

  // function objectToQueryString(obj) {
  //   return Object.keys(obj)
  //     .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
  //     .join('&');
  // }

  function objectToQueryString(obj) {
  const params = [];
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (Array.isArray(value)) {
      value.forEach((v) => {
        params.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`);
      });
    } else if (value !== null && value !== undefined && value !== '') {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });
  return params.join('&');
}

  const downloadExcel = (e) => {

    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/employees/export-working-hours?${queryString}`, '_blank');

  }

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    // delete backendErrors[Input_name];
  };
  // const handleSelectChangeOrder = (selectedOption) => {
  //   setFormData({ ...formData, location: selectedOption ? selectedOption.value : null });
  // };

  const handleSelectChangeOrder = (selectedOption) => {
    // setFormData({ ...formData, location: selectedOption ? selectedOption.value : null });
    const updatedFormData = {
      ...formData,
      location: selectedOption ? selectedOption.value : null
    };

    setFormData(updatedFormData);
    axios
      .post("/employees/listing-active-emp-seasonal", updatedFormData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          let emps = response.data.data.employees;
          let emp_statusList = emps.map((ord, index) => ({
            label: ord.first_name + ' ' + ord.last_name,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setEmployeeslist(emp_statusList);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });
    axios.post("/employees/listing-active-emp-seasonal-working-hours", updatedFormData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  // Handler for multi-select
  const handleSelectMatricule = (selectedOptions) => {
    // selectedOptions will be an array when isMulti is true
    const matriculeValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFormData({ ...formData, matricule: matriculeValues });
  };
  // Handler for multi-select
  const handleSelectEquipe = (selectedOptions) => {
    // selectedOptions will be an array when isMulti is true
    const matriculeValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFormData({ ...formData, equipe: matriculeValues });
  };
  const handleSelectChangeEmp = (selectedOption) => {
    setFormData({ ...formData, employee: selectedOption ? selectedOption.value : null });
  };
  const handleSelectChangeShift = (selectedOption) => {
    // setFormData({ ...formData, shift: selectedOption ? selectedOption.value : null });

    const updatedFormData = {
      ...formData,
      shift: selectedOption ? selectedOption.value : null
    };
    setFormData(updatedFormData);
    axios
      .post("/employees/listing-active-emp-seasonal", updatedFormData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          let emps = response.data.data.employees;
          let emp_statusList = emps.map((ord, index) => ({
            label: ord.first_name + ' ' + ord.last_name,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setEmployeeslist(emp_statusList);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });
    axios.post("/employees/listing-active-emp-seasonal-working-hours", updatedFormData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });


  };


  const handleSelectChangeGender = (selectedOption) => {
    // setFormData({ ...formData, gender: selectedOption ? selectedOption.value : null });
    const updatedFormData = {
      ...formData,
      gender: selectedOption ? selectedOption.value : null
    };

    setFormData(updatedFormData);
    axios
      .post("/employees/listing-active-emp-seasonal", updatedFormData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          let emps = response.data.data.employees;
          let emp_statusList = emps.map((ord, index) => ({
            label: ord.first_name + ' ' + ord.last_name,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setEmployeeslist(emp_statusList);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });
    axios.post("/employees/listing-active-emp-seasonal-working-hours", updatedFormData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

        if (response.data.code === 200) {
          setData(response.data.data.employees);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const [rowSelection, setRowSelection] = useState({});

  // // Get selected IDs whenever selection changes
  // const getSelectedIds = () => {
  //   return Object.keys(rowSelection);
  // };



  const addTimeMultiEmployee = async () => {
    if (Object.keys(rowSelection).length < 1) {
      alert("First Select the Employees");
      return; // stop further execution
    }

    console.log(rowSelection);
    let emp_id = rowSelection
    const { value: formValues } = await Swal.fire({
      title: "Employee Work Time Tracking",
      html: '<div style="display: grid;">     <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Date</label>     <input style="margin: 0em 0em 1em 0em !important;" type="date" id="datePicker" class=" swal2-input" value="' + defaultDate + '"><div style="width:100%;">		<div style="width:50%;float:left"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 1</label> 		   <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="start_time_1" class="swal2-input" placeholder="Start Time" ></div>		<div style="width:50%;float:left;"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 1</label> <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="end_time_1" class="swal2-input" placeholder="End Time"></div> </div>    <div style="width:100%;">		<div style="width:50%;float:left"> <label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> Start time 2</label> 		   <input type="time" style="width:100%;margin: 0em 0em 1em 0em !important;" id="start_time_2" class="swal2-input" placeholder="Start Time"></div>		<div style="width:50%;float:left;"><label style="text-align: left; padding-left: 6px;margin-bottom:3px;display: block;"> End Time 2</label> <input type="time" style="width:100%;;margin: 0em 0em 1em 0em !important;" id="end_time_2" class="swal2-input" placeholder="End Time" ></div> </div>      <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift</label>   <input style="margin: 0em 0em 1em 0em !important;" type="text" id="shift"  class="swal2-input" placeholder="Enter Shift">    <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Shift Hours</label>   <input style="margin: 0em 0em 1em 0em !important;" type="text" id="shift_hours" value="0" class="swal2-input" placeholder="Enter Shift Hours">        <input type="hidden" id="extra_hours" class="swal2-input" value="0" placeholder="Extra Hours">    <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Advance On Salary</label>     <input type="number"  style="margin: 0em 0em 1em 0em !important;" value="0" id="advanced_on_salary" class="swal2-input" placeholder="Advance On Salary"> <div style="text-align: left; padding-left: 5px; margin-top: -20px;">Holiday shift<input type="checkbox"  id="holiday_shift" class="swal2-input" style="margin: 0; position: relative; top: 20px; left: 12px;"></div></div>',

      didOpen: () => {
        const calculateShiftHours = () => {
          const start_time_1 = document.getElementById('start_time_1').value;
          const end_time_1 = document.getElementById('end_time_1').value;
          const start_time_2 = document.getElementById('start_time_2').value;
          const end_time_2 = document.getElementById('end_time_2').value;

          const timeToMinutes = (time) => {
            if (!time) return null;
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
          };

          const getHoursDiff = (startMinutes, endMinutes) => {
            let diff = endMinutes - startMinutes;
            if (diff < 0) diff += 24 * 60; // crosses midnight
            return diff / 60;
          };

          let totalShiftHours = 0;

          if (start_time_1 && end_time_1) {
            const startMins = timeToMinutes(start_time_1);
            const endMins = timeToMinutes(end_time_1);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          if (start_time_2 && end_time_2) {
            const startMins = timeToMinutes(start_time_2);
            const endMins = timeToMinutes(end_time_2);
            totalShiftHours += getHoursDiff(startMins, endMins);
          }

          document.getElementById('shift_hours').value = totalShiftHours.toFixed(2);
        };

        document.getElementById('start_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_1').addEventListener('input', calculateShiftHours);
        document.getElementById('start_time_2').addEventListener('input', calculateShiftHours);
        document.getElementById('end_time_2').addEventListener('input', calculateShiftHours);
      },


      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        const date = document.getElementById('datePicker').value;
        const shift = document.getElementById('shift').value;
        const shift_hours = document.getElementById('shift_hours').value;
        const extra_hours = document.getElementById('extra_hours').value;
        const advanced_on_salary = document.getElementById('advanced_on_salary').value;

        const start_time_1 = document.getElementById('start_time_1').value;
        const start_time_2 = document.getElementById('start_time_2').value;
        const end_time_1 = document.getElementById('end_time_1').value;
        const end_time_2 = document.getElementById('end_time_2').value;


        let holiday_shift = 0;
        if (document.getElementById('holiday_shift').checked) {
          holiday_shift = 1;
        } else {
          holiday_shift = 0;
        }
        if (!date) {
          Swal.showValidationMessage('Date is required');
          return null;
        }
        if (!start_time_1 && !end_time_1) {
          Swal.showValidationMessage('Time is required');
          return null;
        }
        if (!extra_hours) {
          Swal.showValidationMessage('Extra Hours is required');
          return null;
        }
        if (!advanced_on_salary) {
          Swal.showValidationMessage('Advance On Salary is required');
          return null;
        }

        return { emp_id, date, shift_hours, shift, extra_hours, holiday_shift, advanced_on_salary, start_time_1, start_time_2, end_time_1, end_time_2 };
      }
    });

    if (formValues) {
      try {
        const response = await axios.post(`/multiple-employee-work-time-tracking`, {
          season_id: season_id,
          employee_id: formValues.emp_id,
          date: formValues.date,
          shift_hours: formValues.shift_hours,
          shift: formValues.shift,
          extra_hours: formValues.extra_hours,
          holiday_shift: formValues.holiday_shift,
          advanced_on_salary: formValues.advanced_on_salary,
          start_time_1: formValues.start_time_1,
          start_time_2: formValues.start_time_2,
          end_time_1: formValues.end_time_1,
          end_time_2: formValues.end_time_2
        }, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        });

        if (response.data.code === 200) {
          Swal.fire(
            'Success!',
            'Employee Work Time Tracking added Successfully.',
            'success'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'There was a problem Employee Work Time Tracking.',
          'error'
        );
      }
    }
  };


  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Employees Work Time Tracking</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Employees Work Time Tracking</li>
                </ul>
              </div>

            </div>
          </div>
          <div id="filter_inputs" className="card filter-card2">

            <div className="card-body p-10">
              <form onSubmit={handleSubmit}>
                <div className="row">


                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>
                      <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Employee:</label>

                      <Select

                        options={employeeslist}
                        name="employee"
                        value={employeeslist.find(option => option.value === formData.employee) || null}
                        onChange={(selectedOption) => handleSelectChangeEmp(selectedOption)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Shift</label>
                      <Select
                        className="w-100"
                        value={shiftlist.find(option => option.value === formData.shift) || null}

                        name="shift"
                        onChange={(selectedOption) => handleSelectChangeShift(selectedOption)}
                        options={shiftlist}
                        placeholder="Select"

                      />

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Location:</label>
                      <Select
                        options={locationLoading}
                        name="location"
                        value={locationLoading.find(option => option.value === formData.location) || null}
                        onChange={(selectedOption) => handleSelectChangeOrder(selectedOption)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Matricule</label>
                      <Select
                        className="w-100"
                        value={matriculelist.filter(option =>
                          formData.matricule && formData.matricule.includes(option.value)
                        )}
                        name="matricule"
                        onChange={handleSelectMatricule}
                        options={matriculelist}
                        placeholder="Select"
                        isMulti
                      />

                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Gender</label>
                      <Select
                        className="w-100"
                        value={genderlist.find(option => option.value === formData.gender) || null}
                        name="gender"
                        onChange={(selectedOption) => handleSelectChangeGender(selectedOption)}
                        options={genderlist}
                        placeholder="Select"

                      />

                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Equipe:</label>
                      {/* <input type="text" name="equipe" className="form-control" value={formData.equipe} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} /> */}
                       <Select
                        className="w-100"
                        value={equipelist.filter(option =>
                          formData.equipe && formData.equipe.includes(option.value)
                        )}
                        name="equipe"
                        onChange={handleSelectEquipe}
                        options={equipelist}
                        placeholder="Select"
                        isMulti
                      />

                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/work-time-tracking" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>


                    </div>
                  </div>


                  <div className="col-md-5" style={{ paddingTop: '30px' }}>
                    <button style={{ float: "right" }} className="btn btn-primary" onClick={() => addTimeMultiEmployee()} >
                      Working hours<i className="fa fa-file-excel-o"></i>
                    </button>
                  </div>
                  <div className="col-md-2" style={{ paddingTop: '30px' }}>
                    <button style={{ float: "right" }} className="btn btn-primary" onClick={() => downloadExcel()} >
                      Download Working Hours<i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                    </button>
                  </div>
                </div>

              </form>

            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    {permission && permission.list == 1 && (
                      <MaterialReactTable
                        columns={columns}
                        data={data}
                        enableColumnOrdering
                        enableRowSelection
                        enablePinning
                        state={{ rowSelection }}
                        onRowSelectionChange={setRowSelection}
                        getRowId={(originalRow) => originalRow.id}
                        muiSelectAllCheckboxProps={{
                          onClick: (event) => {
                            if (event.target.checked) {
                              // Select all rows
                              const allRowsSelected = data.reduce((acc, row) => {
                                acc[row.id] = true;
                                return acc;
                              }, {});
                              setRowSelection(allRowsSelected);
                            } else {
                              // Deselect all rows
                              setRowSelection({});
                            }
                          }
                        }}
                        muiSelectCheckboxProps={{
                          // Optional: customize individual checkboxes
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeWorkTime;
